import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { AuthShell, Input } from "@/pages/Login";
import { Checkbox } from "@/components/ui/checkbox";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [terms, setTerms] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!name.trim()) return setError("Vul je naam in.");
    if (password.length < 6) return setError("Wachtwoord moet minimaal 6 tekens zijn.");
    if (password !== confirm) return setError("Wachtwoorden komen niet overeen.");
    if (!terms) return setError("Je moet akkoord gaan met de voorwaarden en het privacybeleid.");
    setLoading(true);
    try {
      await register({ name, email, password, accept_terms: terms });
      navigate(location.state?.from || "/", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="WORD LID" subtitle="Gratis account. Zonder gedoe.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        {error && <p className="rounded-lg border border-[#EF4444]/40 bg-[#EF4444]/10 p-3 text-sm text-[#EF4444]" data-testid="register-error">{error}</p>}
        <Input label="Naam" value={name} onChange={setName} testid="register-name" />
        <Input label="E-mail" type="email" value={email} onChange={setEmail} testid="register-email" />
        <Input label="Wachtwoord" type="password" value={password} onChange={setPassword} testid="register-password" />
        <Input label="Bevestig wachtwoord" type="password" value={confirm} onChange={setConfirm} testid="register-confirm" />
        <label className="flex items-start gap-3 text-sm text-[#A0A0A0]">
          <Checkbox checked={terms} onCheckedChange={setTerms} data-testid="register-terms" className="mt-0.5 border-[#555] data-[state=checked]:bg-[#FF6A00] data-[state=checked]:text-[#111]" />
          <span>Ik ga akkoord met de <Link to="/voorwaarden" className="text-[#FF6A00] hover:underline">algemene voorwaarden</Link> en het <Link to="/privacy" className="text-[#FF6A00] hover:underline">privacybeleid</Link>.</span>
        </label>
        <button type="submit" disabled={loading} data-testid="register-submit" className="flex w-full items-center justify-center gap-2 rounded-full bg-[#FF6A00] py-3.5 font-bold text-[#111] transition-all hover:bg-[#FFB27A] active:scale-95 disabled:opacity-60">
          {loading && <Loader2 className="h-5 w-5 animate-spin" />} Registreren
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-[#A0A0A0]">Al een account? <Link to="/inloggen" data-testid="go-login" className="font-semibold text-[#FF6A00] hover:underline">Inloggen</Link></p>
    </AuthShell>
  );
}
